import { render, staticRenderFns } from "./ShoppingCartMobile.vue?vue&type=template&id=08678087&scoped=true"
import script from "./ShoppingCartMobile.vue?vue&type=script&lang=js"
export * from "./ShoppingCartMobile.vue?vue&type=script&lang=js"
import style0 from "./ShoppingCartMobile.vue?vue&type=style&index=0&id=08678087&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08678087",
  null
  
)

export default component.exports